import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { Middleware } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { getNestedErrorMessage } from 'utils/general/getNestedErrorMessage'

export const errorHandlerMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errorMessage: string =
      (getNestedErrorMessage(action?.payload?.data) || action?.error?.message) ??
      'Something went wrong.'

    toast.error(errorMessage)
  }

  return next(action)
}
